import {
  FETCH_CONVERSACIONES_USERS_SUCCESS,
  FETCH_CONVERSACIONES_USERS_REQUEST,
  FETCH_CONVERSACIONES_USERS_FAILURE,
  FETCH_MENSAJES_CONVERSACION_REQUEST,
  FETCH_MENSAJES_CONVERSACION_SUCCESS,
  FETCH_MENSAJES_CONVERSACION_FAILURE,
  SET_NUEVO_MENSAJE_CONVERSACION,
  SET_CONVERSACION_SELECCIONADA,
  SET_UPDATE_LAST_MESSAGE,
  SET_NUEVA_CONVERSACION,
  UPDATE_MENSAJE_CONVERSACION
} from "../../../../constants/chat/Conversaciones/Conversaciones";
import { ConversacionesUsers, Mensajes } from "../../../../types/chat/conversaciones/Conversaciones";

interface ConversacionesState {
  chat_conversaciones: ConversacionesUsers[];
  conversacion_seleccionada: ConversacionesUsers | null;
  mensajes_conversacion: Mensajes[] | null
  loading: boolean;
  success: boolean;
  error: string | null;
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
  paginationMensajes: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

const INIT_STATE: ConversacionesState = {
  chat_conversaciones: [],
  mensajes_conversacion: [],
  conversacion_seleccionada: null,
  loading: false,
  success: false,
  error: null,
  pagination: {
    total: 0,
    page: 1,
    limit: 20,
    totalPages: 0
  },
  paginationMensajes: {
    total: 0,
    page: 1,
    limit: 30,
    totalPages: 0
  },
};

export default (state = INIT_STATE, action: any): ConversacionesState => {
  switch (action.type) {
    case FETCH_CONVERSACIONES_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_CONVERSACIONES_USERS_SUCCESS:
      const dataTest = action.payload.meta.page === 1
          ? action.payload.data
          : [...(state.chat_conversaciones || []), ...action.payload.data]

      return {
        ...state,
        loading: false,
        chat_conversaciones: action.payload.meta.page == 1
          ? action.payload.data
          : [...(state.chat_conversaciones || []), ...action.payload.data],
        pagination: action.payload.meta
      };
    case FETCH_CONVERSACIONES_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case FETCH_MENSAJES_CONVERSACION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_MENSAJES_CONVERSACION_SUCCESS:

      const initialMessages = action.payload.meta.skip

      const messages = initialMessages == 0
        ? action.payload.data
        : [...(state.mensajes_conversacion || []), ...(action.payload.data || [])]

      return {
        ...state,
        loading: false,
        mensajes_conversacion: messages,
        paginationMensajes: action.payload.meta
      };
    case FETCH_MENSAJES_CONVERSACION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case SET_CONVERSACION_SELECCIONADA:
      return {
        ...state,
        conversacion_seleccionada: action.payload,
        mensajes_conversacion: [],
        paginationMensajes: {
          total: 0,
          page: 1,
          limit: 30,
          totalPages: 0
        }
      };

    case SET_NUEVO_MENSAJE_CONVERSACION:

      return {
        ...state,
        mensajes_conversacion: [action.payload, ...(state.mensajes_conversacion || [])]
      };

    case SET_UPDATE_LAST_MESSAGE:
      const conversationId = action.payload.conversacionId;

      const data_conversaciones = state.chat_conversaciones.map(conversacion =>
        conversacion.id === conversationId
          ? { ...conversacion, mensaje: action.payload }
          : conversacion
      );

      return {
        ...state,
        chat_conversaciones: data_conversaciones.sort((a, b) =>
          new Date(b.mensaje?.createdAt).getTime() - new Date(a.mensaje?.createdAt).getTime()
        )
      };

    case SET_NUEVA_CONVERSACION:

      const filtrar_conversaciones = (state.chat_conversaciones || []).filter(
        (cnv: any) => cnv?.user?.id !== action.payload?.user?.id
      );

      const data_nueva_conversacion = [action.payload, ...filtrar_conversaciones];

      return {
        ...state,
        chat_conversaciones: data_nueva_conversacion.sort((a, b) =>
          new Date(b.mensaje?.createdAt).getTime() - new Date(a.mensaje?.createdAt).getTime()
        )
      };

    case UPDATE_MENSAJE_CONVERSACION:

      const data_mensajes = state.mensajes_conversacion?.map(mensaje =>
        mensaje.id == action.payload.id
          ? { ...mensaje, ...action.payload }
          : mensaje
      );

      return {
        ...state,
        mensajes_conversacion: data_mensajes || []
      };


    default:
      return state;
  }
}